import { api } from '@/lib/api/client';
import type { AutoTradeConfig, AutoTradeOrder } from './autoTradeTypes';

/**
 * 자동매매 조회 API. (2026-09-20, BACKLOG I-5 A3)
 *
 * 🔴 조회만 있다. 설정을 바꾸는 함수를 만들지 않는다
 *   모드를 올리려면 재인증(패스키·OTP)이 필요한데 그것이 아직 없다(A5).
 *   재인증 없이 모드를 바꾸는 길을 먼저 열면, 나중에 재인증을 붙여도
 *   **그 우회로가 남는다.** CLAUDE.md 1.1 조건 3 이 무력해진다.
 *
 *   A5 까지는 설정을 DB 로만 만든다. 그림자는 돈이 움직이지 않으므로
 *   그렇게 켜도 안전하다.
 *
 * 🔴 이 경로도 TRADING_ACCOUNT 메뉴 권한을 요구한다
 *   내 실계좌를 움직이는 설정이라 가족에게 열지 않는다. (accountApi 와 같은 원칙)
 */

/** 내 자동매매 설정. 아직 만들지 않았으면 null 이 온다. */
export async function fetchAutoTradeConfig(
  country = 'KR',
): Promise<AutoTradeConfig | null> {
  return api.get<AutoTradeConfig | null>('/trading/autotrade/config', { country });
}

/**
 * 최근 주문 시도. 🔴 그림자와 한도에 막힌 것까지 전부 온다.
 *
 * 성공한 것만 보면 "신호가 없었다" 와 "신호는 있었는데 막혔다" 를
 * 구분할 수 없다. 둘은 전혀 다른 상황이다.
 */
export async function fetchAutoTradeOrders(days = 7): Promise<AutoTradeOrder[]> {
  return api.get<AutoTradeOrder[]>('/trading/autotrade/orders', { days });
}
